import { SalesminerAccount } from '@/types/serializers'
import { Users } from 'lucide-react'
import AccountCard from './_components/AccountCard'
import SalesminerAppLayout from "@/salesminer/layouts/SalesminerAppLayout.tsx";

interface Props {
    accounts: SalesminerAccount[]
    user: {
        name: string
        email: string
    }
    organization: {
        name: string
        slug: string
    }
}

export default function Index({accounts, organization}: Props) {

    return (<SalesminerAppLayout>
            <div className="p-6">
                <div className="max-w-7xl mx-auto">
                    {/* Page Header */}
                    <div className="mb-8">
                        <h1 className="text-3xl font-bold text-gray-900 dark:text-white">Client Accounts</h1>
                        <p className="mt-2 text-gray-600 dark:text-gray-300">Manage your client accounts and track
                            opportunities</p>
                    </div>

                    {/* Accounts Grid */}
                    {accounts && accounts.length > 0 ? (
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                            {accounts.map((account) => (
                                <AccountCard key={account.id} account={account} organization={organization}/>
                            ))}
                        </div>
                    ) : (
                        <div className="text-center py-12">
                            <Users className="w-12 h-12 text-gray-300 dark:text-gray-600 mx-auto mb-4"/>
                            <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">
                                No client accounts yet
                            </h3>
                            <p className="text-gray-500 dark:text-gray-400">
                                Get started by adding your first client account.
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </SalesminerAppLayout>
    )
}